import * as bootstrap from 'bootstrap';
import { clearParentAttendanceFields } from './parentInfo';

export function initStudentInfo() {

  // console.log("Student Info initiated");
  
  const studentType = document.getElementById("studentType");
  const raceDropdown = document.getElementById('raceDropdownMenu');
  const raceButton = document.getElementById('raceDropdownButton');
  const otherRaceContainer = document.getElementById('otherRaceContainer');
  const otherRaceCheckbox = document.getElementById('raceOther');
  const otherRaceInput = document.getElementById('otherRaceInput');
  const closeDropdownButton = document.getElementById('closeDropdownButton');
  
  // FIX: Fetch the element's existing dropdown panel controller instead of building a duplicate
  const bsDropdown = raceButton ? bootstrap.Dropdown.getOrCreateInstance(raceButton) : null;

  const studentGender = document.getElementById('studentGender');
  const selfDescribeGenderWrapper = document.getElementById('selfDescribeGenderWrapper');
  const studentGenderCustom = document.getElementById('studentGenderCustom');

  if (studentGender) { studentGender.addEventListener('change', handleGenderChange); }
  if (studentType) { studentType.addEventListener('change', handleStudentTypeChange); }
  if (raceDropdown) { raceDropdown.addEventListener('change', handleRaceChange); }
  
  // Cleanly close out the panel when user clicks the "X" anchor
  if (raceDropdown && closeDropdownButton && bsDropdown) { 
    closeDropdownButton.addEventListener('click', function (e) {
      e.stopPropagation(); // Stop the close click from re-toggling the view state
      bsDropdown.hide();
    });
  }

  function handleStudentTypeChange() {
    const payCommitFeeButton = document.getElementById("payCommitFeeButton");
    const submitRegFormButton = document.getElementById("submitRegFormButton");
    const returningStudentAddonWrapper = document.getElementById('returningStudentAddonWrapper');
    const parentAttendingBeginner = document.getElementById('parentAttendingBeginner');
    const commitmentFeeAlert = document.getElementById('commit-fee-alert');

    if (studentType.value === '2' || studentType.value === '3') {
      if (payCommitFeeButton) payCommitFeeButton.classList.add('d-none');
      if (submitRegFormButton) submitRegFormButton.classList.remove('d-none');
      if (returningStudentAddonWrapper) returningStudentAddonWrapper.classList.remove('d-none');
      if (parentAttendingBeginner) parentAttendingBeginner.setAttribute('required', 'required');
      if (commitmentFeeAlert) commitmentFeeAlert.classList.add('d-none');
    } else {
      if (payCommitFeeButton) payCommitFeeButton.classList.add('d-none');
      if (submitRegFormButton) submitRegFormButton.classList.remove('d-none');
      if (returningStudentAddonWrapper) returningStudentAddonWrapper.classList.add('d-none');
      if (parentAttendingBeginner) parentAttendingBeginner.removeAttribute('required');
      if (commitmentFeeAlert) commitmentFeeAlert.classList.add('d-none');
      
      clearParentAttendanceFields();
    }
  }

  function handleRaceChange() {
    console.log("[Race Filter] Evaluating checked profile categories...");
    const checkedBoxes = raceDropdown.querySelectorAll('.race-checkbox:checked');
    
    if (checkedBoxes.length > 0) {
      const selectedText = Array.from(checkedBoxes).map(cb => cb.value).join(', ');
      if (raceButton) raceButton.textContent = selectedText;
    } else {
      if (raceButton) raceButton.textContent = 'Select...';
    }

    if (otherRaceCheckbox && otherRaceCheckbox.checked) {
      if (otherRaceContainer) otherRaceContainer.classList.remove('d-none');
      if (otherRaceInput) otherRaceInput.focus();
    } else {
      if (otherRaceContainer) otherRaceContainer.classList.add('d-none');
      if (otherRaceInput) otherRaceInput.value = '';
    }
  }

  function handleGenderChange() {
    if (studentGender.value === 'Prefer to self-describe') {
      if (selfDescribeGenderWrapper) selfDescribeGenderWrapper.classList.remove('d-none');
      if (studentGenderCustom) studentGenderCustom.setAttribute('required', 'required');
    } else {
      if (selfDescribeGenderWrapper) selfDescribeGenderWrapper.classList.add('d-none');
      if (studentGenderCustom) {
        studentGenderCustom.removeAttribute('required');
        studentGenderCustom.value = '';
      }
    }
  }
}

export function getSelectedRaceEthnicity() {
  const checkedBoxes = document.querySelectorAll('#raceDropdownMenu .race-checkbox:checked');
  let selections = Array.from(checkedBoxes).map(checkbox => checkbox.value);
  const otherCheckbox = document.getElementById('raceOther');
  const otherInput = document.getElementById('otherRaceInput');
  
  if (otherCheckbox && otherCheckbox.checked && otherInput) {
    const otherValue = otherInput.value.trim();
    selections = selections.filter(value => value !== 'Other');
    if (otherValue !== '') {
      selections.push(`Other: ${otherValue}`);
    } else {
      selections.push('Other (unspecified)');
    }
  }
  return selections;
}